// extracted by mini-css-extract-plugin
module.exports = {"socialLink":"styles_socialLink__10YrD","grey":"styles_grey__3m-VK","black":"styles_black__1Fy-F","hidden":"styles_hidden__1h2OI"};